import { render, staticRenderFns } from "./PageForms.vue?vue&type=template&id=5f30eb56&scoped=true&"
import script from "./PageForms.vue?vue&type=script&lang=js&"
export * from "./PageForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f30eb56",
  null
  
)

export default component.exports